import axios from 'axios'
import siteOptions from '@/config/index'

const serverBasePath = siteOptions['serverBasePath'] || '';
const $http = axios.create({
  headers: {'X-Requested-With': 'XMLHttpRequest'}
})

// http 请求拦截.
$http.interceptors.request.use(
  siteOptions["ajaxRequestFilter"](axios),
  siteOptions["ajaxRequestError"]
)

// http 响应拦截.
$http.interceptors.response.use(
  siteOptions['ajaxResponseFilter'] || (response=>response.data),
  siteOptions["ajaxResponseError"]
)

export default{
  axios,
  $http,
  customizeHttp(options){
    return this.$http = this.axios.create(options)
  },
	get (url, params, callback) {
		return this.$http.get(url, {
      params: params
    })
	},
  post (url, params, callback) {
    return this.$http.post(url, params)
  },
  makeApiMethod(source, target, method) {
  	let getApiNames = Object.keys(source)
  	getApiNames.forEach(apiName=>{
      target[apiName] = (params)=>{
        return this[method || 'get'](serverBasePath + source[apiName], params)
      }
  	})
  }
}
